import React, { Component } from 'react';
import './collapsibleBox.css';

class CollapsibleBox extends Component {
    render() {
        const { 
            icon, 
            title, 
            subtitle,
            isOpen, 
            onToggle, 
            children 
        } = this.props;

        return (
            <div className={`collapsible-box ${isOpen ? 'collapsible-box--open' : ''}`}>
                <div 
                    className="collapsible-box__header" 
                    onClick={onToggle}
                    role="button"
                    tabIndex={0}
                    onKeyPress={(e) => e.key === 'Enter' && onToggle()}
                >
                    <div className="collapsible-box__header-left">
                        <img 
                            src={icon} 
                            alt="" 
                            className="collapsible-box__icon" 
                        />
                        <div className="collapsible-box__title-container">
                            <h3 className="collapsible-box__title">{title}</h3>
                            {subtitle && (
                                <p className="collapsible-box__subtitle">{subtitle}</p>
                            )}
                        </div>
                    </div>
                    <div className={`collapsible-box__chevron ${isOpen ? 'collapsible-box__chevron--up' : ''}`}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6 9L12 15L18 9" stroke="#004CC6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                </div>
                <div className={`collapsible-box__content ${isOpen ? 'collapsible-box__content--visible' : ''}`}>
                    {children}
                </div>
            </div>
        );
    }
}

export default CollapsibleBox;

